// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__GfS9M","input":"styles_input__MCuVW","wrapper":"styles_wrapper__qjr7N"};